//setting fitty.js(url: https://github.com/rikschennink/fitty)
fitty('#category-row', {
	minSize: 4
});

// section3 lider ライブラリ:keen-slider.js(url: https://keen-slider.io/examples)
function slider01Init() {
    var slider = new KeenSlider('#uniform-slider', {
        loop: true,
        defaultAnimation: {
          duration: 3000,
        },
        detailsChanged: (s) => {
          	s.slides.forEach((element, idx) => {
            	element.style.opacity = s.track.details.slides[idx].portion;
          	})
        },
        renderMode: "custom",
    });
}

// accordionの初期化
function　initAccordion() {
	const target = document.querySelectorAll('.section3__accordion__text');

	if(window.innerWidth < 1180) {
		target.forEach(e => {
			const children = e.firstElementChild;
	
			e.style.height = 'auto';
			e.style.maxHeight = 0;
		});
	} else {
		target.forEach(e => {
			const children = e.firstElementChild;
			const height = children.offsetHeight + 60;
	
			e.style.height = `${height}px`;
		});
	}
}

// スライダーがスワイプできることを知らせる画像を表示する
function sliderGuidance() {
	const item = document.querySelector('.section3__slider-wrapper');
	const target = document.querySelector('.slider-guidance');
	const callback = (entry) => {
		entry.forEach(e => {
			if(e.isIntersecting) {
				target.style.animationName = 'appear-guidance';
			}
		});
	};
	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5
	};
	const observer = new IntersectionObserver(callback, options);

	observer.observe(item);
}

// section5 slider 2
function slider02Init() {
	const buttons = document.querySelectorAll('.section5__slider-controller__button');
	const detailWrapper = document.querySelector('.section5__slider-detail-wrapper');
	const detail = document.querySelectorAll('.section5__slider-detail');

	var slider = new KeenSlider('#flow-slider', {
		loop: true,
		defaultAnimation: {
		duration: 500,
		}},
		[
			slider => {
			slider.on('created', () => {
				const height = detail[0].clientHeight;

				detailWrapper.style.height = `${height}px`
			});
		  },
		]
	);

	buttons.forEach((button, idx) => {
		button.addEventListener('click', () => {
			slider.moveToIdx(idx);
		});
	});

	slider.on("animationEnded", (main) => {
		detail.forEach((e, idx) => {
			e.classList.remove('active');
			if(idx == (main.track.details.rel)) {
				const height = e.clientHeight;

				detailWrapper.style.height = `${height}px`;
				e.classList.add('active');

				buttons.forEach((e,i) => {
					e.classList.remove('under-line');

					if(i == idx) {
						e.classList.add('under-line');
					}
				});
			}
		});
	});
}

// init
window.onload = [
    slider01Init(),
    initAccordion(),
	sliderGuidance(),
    slider02Init()
] 

// リサイズ対応
window.addEventListener('resize', () => {
	initAccordion();
});